<!-- 弹窗表单 -->
<template>
  <a-modal
    :visible="visible"
    :width="`${width}vw`"
    :title="title"
    :ok-text="$t('common.submit')"
    :cancel-text="$t('common.cancel')"
    :maskClosable="false"
    @ok="handleSearch"
    @cancel="cancel"
  >
    <a-form
      class="ant-advanced-search-form"
      :form="form"
      :labelCol="{ span: labelwidth }"
    >
      <a-row :gutter="24">
        <a-col
          v-for="(item, index) in formlist"
          :key="index"
          :span="24 / column"
          v-if="!item.hide"
        >
          <a-form-item :label="item.label">
            <a-input
              v-if="item.type == 'input'"
              v-decorator="[item.value, item.rules]"
              :placeholder="item.placeholder"
              :type="item.vType ? item.vType : 'text'"
            />
            <a-date-picker
              valueFormat="YYYY-MM-DD"
              v-if="item.type == 'date'"
              :placeholder="item.placeholder"
              style="width: 100%"
              v-decorator="[item.value, item.rules]"
            />


            <a-time-picker
              value-format="HH:mm:ss"
              v-if="item.type == 'datetime'"
              :placeholder="item.placeholder"
              style="width: 100%"
              v-decorator="[item.value, item.rules]"
            />

            <a-select
              
              v-if="item.type == 'select'"
              style="width: 100%"
              v-decorator="[item.value, item.rules]"
              :placeholder="item.placeholder"
              @change="(value) => handleSelectChange(value, item.value)"
              :getPopupContainer="triggerNode => triggerNode.parentNode"
            >
              <a-select-option
                v-for="keys in item.options"
                :key="keys.value"
                :value="keys.value"
              >
                {{ keys.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import i18n from "../lang/i18n";
export default {
  props: {
    title: {
      type: String,
      default: i18n.t('common.modalForm'),
    },
    visible: {
      type: Boolean,
      default: false,
      require: true,
    },
    width: {
      type: Number,
      default: 50,
    },
    formlist: {
      type: Array,
      require: true,
    },
    datas: {
      type: Object,
    },
    column: {
      type: Number,
      default: 2,
    },
    labelwidth: {
      type: String,
      default: "5",
    },
  },
  name: "",
  data() {
    return {
      form: this.$form.createForm(this, { name: "form" }),
    };
  },
  methods: {
    handleSearch(e) {
      e.preventDefault();
      this.form.validateFields((error, values) => {
        if (!error) {
          console.log("验证成功 ", values);
          this.$emit("change", values);
        }
      });
    },
    
    handleSelectChange(value, fieldName){
      if(value == '局域网' ){
        this.$emit('selectChange',true, 'cklx')
      }

      if(value == '萤石云' ){
        this.$emit('selectChange',false, 'cklx')
      }

      console.log(value, fieldName)

      if(value == '平方仓'){
        this.$emit('selectChange',true, 'cklx')
      }
      if(value == '圆筒仓'){
        this.$emit('selectChange',false, 'cklx')
      }
      
      // 处理异常监测开关
      if(fieldName === 'errorStatus'){
        this.$emit('selectChange', value, 'errorStatus')
      }
    },
    cancel() {
      this.form.resetFields();
      this.$emit("update:visible", false);
    },
  },
  computed: {},
  watch: {
    visible: {
      handler(newVal) {
        if (newVal == false) {
          this.form.resetFields();
        } else if (newVal == true && this.datas) {
          setTimeout(() => {
            this.form.setFieldsValue(this.datas);
          }, 0);
        }
      },
      deep: true,
      immediate: true,
    },
    datas: {
      handler(newVal) {
        console.log("数据更新");
        if (this.visible && newVal) {
          setTimeout(() => {
            this.form.setFieldsValue(newVal);
            this.$forceUpdate();
          }, 0);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {
    // 不在mounted阶段设置表单值，避免渲染前设置的警告
  },
};
</script>

<style lang="scss" scoped>
.ant-advanced-search-form .ant-form-item {
  display: flex;
  margin-bottom: rem(10);
}
:deep(.ant-advanced-search-form .ant-form-item-control-wrapper) {
  flex: 1 !important;
}
</style>